/**
 * Banco de preguntas del curso: 4 por lección (332 en total), multiple choice con UNA
 * correcta y su explicación. Vive acá, versionado con el catálogo, y NO en Mongo: los
 * intentos guardan el id de pregunta (`<lessonKey>#<n>`) y el texto se resuelve contra el
 * catálogo vigente.
 *
 * La respuesta correcta nunca sale al cliente antes de corregir: el server sirve
 * `toPublicQuestion()` y corrige con `getTrainingQuestion()`.
 */
import { CONTENT_BY_MODULE } from "./content/index.js";
import { TRAINING_LESSONS } from "./catalog.js";
/** Preguntas por lección que exige el curso. */
export const QUESTIONS_PER_LESSON = 4;
/** Todas las preguntas, en el orden del curso. */
export const TRAINING_QUESTIONS = TRAINING_LESSONS.flatMap((lesson) => CONTENT_BY_MODULE[lesson.module].questions.filter((q) => q.lessonKey === lesson.key));
const QUESTIONS_BY_ID = new Map(TRAINING_QUESTIONS.map((q) => [q.id, q]));
export function getTrainingQuestion(id) {
    return QUESTIONS_BY_ID.get(id);
}
export function questionsForLesson(lessonKey) {
    return TRAINING_QUESTIONS.filter((q) => q.lessonKey === lessonKey);
}
/** La pregunta sin la respuesta ni la explicación. */
export function toPublicQuestion(question) {
    return {
        id: question.id,
        lessonKey: question.lessonKey,
        prompt: question.prompt,
        options: question.options.map((option) => ({ id: option.id, text: option.text })),
    };
}
//# sourceMappingURL=quizzes.js.map